import React from "react";
import { MdMail, MdPhoneCallback } from "react-icons/md";
import { useTranslation } from "react-i18next";
import ContactForm from "./ContactForm";

const Footer = () => {
  const { t } = useTranslation("common");

  return (
    <footer className="bg-primary text-white relative px-[5%]" id="contact">
      <div className="w-full pt-2 sm:pt-4 md:pt-6 maxContainer">
        <div className="flex flex-wrap justify-between gap-8 pb-8">
          <div className="flex flex-col md:w-1/4">
            <p className="pb-5 sm:text-[18px] max-w-[225px] font-semibold">
              {t("footerInfo1Title")}
            </p>
            <ul className="text-[14px] mb-8">
              <li className="pb-1 font-semibold">
                {t("footerInfo1SubTitle1")}
              </li>
              <li className="pb-1">Kristupas Naujokas</li>
              <li className="flex items-center gap-2 pb-1">
                <MdPhoneCallback /> <span>+370 640 67376</span>
              </li>
              <li className="flex items-center gap-2 ">
                <MdMail />{" "}
                <a
                  href="mailto:kristupas.naujokas@economus.lt"
                  target="_blank"
                  className="underline transition-transform duration-300 transform hover:text-tertiary"
                  rel="noreferrer"
                >
                  kristupas.naujokas@economus.lt{" "}
                </a>
              </li>
            </ul>
            <ul className="text-[14px] mb-8">
              <li className="pb-1 font-semibold">
                {t("footerInfo1SubTitle2")}
              </li>
              <li className="pb-1">Kornelija Jokimčiute</li>
              <li className="flex items-center gap-2 pb-1">
                <MdPhoneCallback /> <span>+370 666 84272</span>
              </li>
              <li className="flex items-center gap-2 ">
                <MdMail />{" "}
                <a
                  href="mailto:kornelija.jokimciute@economus.lt"
                  target="_blank"
                  className="underline transition-transform duration-300 transform hover:text-tertiary"
                  rel="noreferrer"
                >
                  kornelija.jokimčiute@economus.lt{" "}
                </a>
              </li>
            </ul>
          </div>

          <div className="md:w-1/4 ">
            <p className="pb-5 sm:text-[18px] font-semibold">
              {t("footerInfo2Title")}
            </p>
            <ul className="text-[14px] mb-3">
              <li className="pb-1 font-semibold">UAB Economus</li>
              <li className="pb-2">
                <span className="font-semibold">{t("footerInfoAddress")}</span>{" "}
                Kuosų g. 9-108,
                <br /> Vilnius, LT-10312{" "}
              </li>
            </ul>

            <ul className="text-[14px] mb-3">
              <li className="pb-1 font-semibold">
                {t("footerInfoOfficeAddress")}
              </li>
              <li className="pb-2">
                Senasis Ukmergės kel. 4,
                <br /> Užubaliai, LT-14302 Vilnius.
              </li>
            </ul>

            <ul className=" text-[14px] mb-3">
              <li className="pb-1 font-semibold">
                <span className="font-semibold">
                  {t("footerInfoCompanyCode")}
                </span>{" "}
                300582646
              </li>
              <li className="pb-2">
                <span className="font-semibold">{t("footerInfoVatNo")}</span>{" "}
                LT100002704415.
              </li>
            </ul>
          </div>

          <div className="md:w-1/4">
            <p className="pb-5 sm:text-[18px] font-semibold">
              {t("footerInfo3Title")}
            </p>
            <ul className=" text-[14px] mb-8">
              <li className="pb-2">Mindaugas Jokimčius </li>
              {/* <li className="flex items-center gap-2 ">
                <MdMail />
                <a
                  href="mailto:mindaugas.jokimcius@economus.lt"
                  target="_blank"
                  className="underline transition-transform duration-300 transform hover:text-tertiary"
                  rel="noreferrer"
                >
                  mindaugas.jokimcius@economus.lt{" "}
                </a>
              </li> */}
            </ul>

            <div className="text-[14px]">
              <p className="pb-2 max-w-[225px] font-semibold">
                {t("footerInfo3SubTitle")}
              </p>
              <ul className="mb-3 ">
                <li>
                  {t("footerInfo2SubTitle1")}{" "}
                  <div className="flex items-center gap-2">
                    <MdMail />{" "}
                    <a
                      href="mailto:info@economus.lt"
                      target="_blank"
                      className="underline transition-transform duration-300 transform hover:text-tertiary"
                      rel="noreferrer"
                    >
                      info@economus.lt{" "}
                    </a>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <ContactForm />

        <div className="w-full pt-5 pb-12 border-t sm:pb-10">
          <div className="flex items-center justify-between gap-4">
            <span className="text-[14px] text-center">
              © 2026 Economus. {t("footerAllRightReserved")}
            </span>
            <span className="text-[14px] text-center">{t("footerTC")}</span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
